import React from 'react';
import { db } from '../../../utils/firebase-config';
import { doc, updateDoc } from "firebase/firestore";

const updateUserProgress = async (userId, area, step) => {
    const docRef = doc(db, "users", userId);
    const progress = { [`progress.${area}`]: step };
  
    try {
      await updateDoc(docRef, progress);
      console.log("Progress updated successfully!");
    } catch (error) {
      console.error("Error updating progress: ", error);
    }
  };
export default updateUserProgress;